import GET_ARTICLES from '../plugins/getArticles'
import imagesLoaded from 'imagesloaded';

const [w, d, l, content] = [window, document, location, 'recruit']

const tagList = tags => {
  const $tags = $('<div class="tags"></div>');

  tags.forEach( tag => {
    const $tag = $('<span class="tag"/>');
    $tag.text( tag ).appendTo( $tags );

    switch( tag ) {
      case '新卒':
      $tag.addClass('is-graduate');
      break
      case '中途':
      $tag.addClass('is-career');
    }
  });
  return $tags[0].outerHTML;
};

const detail_init = async the_id => {

  // 詳細書き換え
  if( d.body.classList.contains('is--detail') ){
    let the_id = document.body.getAttribute('class').replace(/^.+is--article-([\d]+)(.+)?$/,'$1');
    let codingPageArr = [1, 2, 3, 4, 5];
    const is_userEdit = () => codingPageArr.indexOf( parseInt( the_id ) ) == -1;

    if ( is_userEdit() ) {
      $('body').addClass('is-userEdit');
      // 全記事取得
      let articles = await $.getArticles({
        content,
        post_id: the_id
      });
      let categories = await $.getCategories({
        content
      });
      let the_article = articles.filter(a => (a.id == the_id)).shift();
      the_article.category = categories.filter(c => c.id == the_article.category)[0];

      let $head = $(`
        <section class="recruit-detail__titleWrap">
          <h2 class="recruit-detail__title">
            <span>REQUIREMENTS</span>
            <small>募集要項</small>
          </h2>
        </section>
        <section class="recruit-detail-head">
          <figure class="recruit-detail-head__img">
            <img src="${the_article.thumb}" alt="" class="recruit-detail__thumb">
          </figure>
          <div class="recruit-detail-head__titleWrap">
            ${the_article.category ? `<span class="cat">${the_article.category.name}</span>`: '<span class="cat">その他</span>' }
            ${the_article.keywords ? tagList(the_article.keywords) : ''}
            <h3 class="title">${the_article.title.replace( /(.)【/g, '$1<br>【')}</h3>
            ${the_article.desc.length ? `<p class="desc">${the_article.desc.replace(/(.)(○|◯)/g, '$1<br>○')}</p>`: '' }
          </div>
          <!-- /.recruit-detail-head__titleWrap -->
        </section>
      `);
      $('.element_detail > .title, .detail_title').remove();

      $head.prependTo('.element_detail');

      //サムネのwidthを半分にして表示
      const elem    = document.querySelector('.recruit-detail-head');
      const callback = () => {
        const $thumbImg = $('.recruit-detail__thumb');
        const thumbWidth = $thumbImg.prop('naturalWidth');
        $thumbImg.width( thumbWidth / 2 );
      };
      imagesLoaded( elem, callback );
    }
  }

  $.when( w.load['recruit-others'] ).then( () => {
    //その他の募集要項 一覧
    let makeItem = item => $(`
    <a href="${item.href}" class="recruit-others-item">
      <div class="recruit-others-item__body">
        ${item.keywords ? tagList(item.keywords) : ''}
        <h4 class="subject">
          <span>${item.title.replace( /(.)【/g, '$1<br>【')}</span>
        </h4>
        <span class="desc">${item.desc.replace(/(.)(○|◯)/g, '$1<br>○')}</span>
      </div>
    </a>`)[0]
    GET_ARTICLES('.recruit-others__list[data-plugin="getArticles"]', {makeItem, exclude: the_id });
  });

}

const init = () => {

  if( w.load['loadHtml'] ) {
    w.load['loadHtml'].then( () => {
      // ナビゲーションカレント
      $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});
    });
  }

  if( w.load['recruit01'] ) {
    $.when( w.load['recruit01'] ).then( () => {
      let makeItem = item => {

        const $item = $(`
          <a href="${item.href}" class="recruit-requirements-item">
            <div class="recruit-requirements-item__body">
              ${item.keywords ? tagList(item.keywords) : ''}
              <h4 class="subject">
                <span>${item.title.replace( /(.)【/g, '$1<br>【')}</span>
              </h4>
              <span class="desc">${item.desc.replace(/(.)(○|◯)/g, '$1<br>○')}</span>
            </div>
          </a>
        `);

        return $item[0];
      }
      GET_ARTICLES('.recruit-requirements__list[data-plugin="getArticles"]', {makeItem}).then(
        items => {
          if ( items.length == 0 ) {
            $('.recruit-requirements__list[data-plugin="getArticles"]').append('<p class="text-center">現在、募集は行っておりません。</p>');
            $('.entryButton', '.recruit-requirements').hide();
          }
        }
      );
    });
  }
}

export default function RECRUIT () {
  $(() => {
    init()
    if (w.query_string('article')) detail_init(w.query_string('article'))
  });
}